import React, { forwardRef, useImperativeHandle } from "react";
import Icon from "../Icon";
import { useFileUpload } from "../../../hook/useFileUpload";

interface FileUploaderProps {
  value?: File[];
  handleFileChange: (files: File[]) => void;
}

export interface FileUploaderHandle {
  removeFile: (uuid: string) => void;
}

const FileUploader = forwardRef<FileUploaderHandle, FileUploaderProps>(
  ({ handleFileChange }, ref) => {
    const {
      getRootProps,
      getInputProps,
      openFileDialog,
      removeFile,
    } = useFileUpload({
      multiple: true,
      maxFiles: 5,
      maxSize: 5 * 1024 * 1024, // 5 MB
      handleFileChange: (files) => {
        handleFileChange(files);
      },
    });

    // Let callers (e.g. the attachment list's remove button) drop a file from
    // the hook's own tracked list — otherwise it resurrects on the next upload.
    useImperativeHandle(ref, () => ({ removeFile }), [removeFile]);

    return (
      <div className="uploader-container">
        {/* Upload area */}
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <button onClick={openFileDialog} className="tool-bar-button" data-tooltip="Attach files">
            <Icon className="upload-icon" name="Attach" />
          </button>
        </div>
      </div>
    );
  },
);

export default FileUploader;
